"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;

var _reactIntl = require("react-intl");

var messages = (0, _reactIntl.defineMessages)({
  languageName: {
    "id": "languageName",
    "defaultMessage": "languageName"
  },
  languageCode: {
    "id": "languageCode",
    "defaultMessage": "languageCode"
  }
});
exports.messages = messages;
//# sourceMappingURL=language-i18n.js.map